import React from 'react';
import { DetailSection } from '@/components/football';
import Button from '@/components/ui/Button';
import DelayedLoading from '@/components/ui/DelayedLoading';
import LoadingStatus from '@/components/ui/LoadingStatus';
import { getV2Error } from '@/services/api/v2';

interface Props {
  title: string;
  query: { isPending: boolean; isError: boolean; isFetching?: boolean; error: unknown; refetch: () => unknown };
  children: React.ReactNode;
  unframed?: boolean;
}

const SectionQuery: React.FC<Props> = ({ title, query, children, unframed = false }) => {
  const hasCachedChildren = children !== null && children !== undefined && children !== false;
  const error = (
    <div role="alert" className={`space-y-3 ${hasCachedChildren ? 'rounded-lg border border-amber-200 bg-amber-50 p-3 text-amber-900 dark:border-amber-800 dark:bg-amber-950/30 dark:text-amber-200' : 'text-red-700 dark:text-red-300'}`}>
      <p>{getV2Error(query.error).message}</p>
      <Button variant="outline" onClick={() => query.refetch()}>Retry</Button>
    </div>
  );
  const content = query.isPending ? (
    <DelayedLoading loading>
      <LoadingStatus variant="panel" label={`Loading ${title.toLowerCase()}`} />
    </DelayedLoading>
  ) : query.isError ? (
    hasCachedChildren ? <div className="space-y-3">{error}{children}</div> : error
  ) : query.isFetching && hasCachedChildren ? (
    <div className="space-y-3">
      <LoadingStatus variant="inline" label={`Refreshing ${title.toLowerCase()}`} />
      {children}
    </div>
  ) : children;

  if (!unframed) return <DetailSection title={title}>{content}</DetailSection>;
  if (!query.isPending && !query.isError) return <>{content}</>;

  return (
    <section aria-label={title} className="rounded-lg bg-white p-4 shadow-sm dark:bg-gray-900 sm:p-5">
      {content}
    </section>
  );
};
export default SectionQuery;
